import { render } from "./ProfileSection.vue?vue&type=template&id=21042175&scoped=true"
import script from "./ProfileSection.vue?vue&type=script&lang=js"
export * from "./ProfileSection.vue?vue&type=script&lang=js"

import "./ProfileSection.vue?vue&type=style&index=0&id=21042175&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21042175"]])

export default __exports__